
import './App.css';
import PathFindingVisualizer from './PathFindingVisualizer/PathFindingVisualizer';


function App() {
  return (
    <div className="App">
       <PathFindingVisualizer></PathFindingVisualizer>
    </div>
  );  
}

export default App;
